import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/punches";

const { actions, types } = createActions({
  setLoading: ["loading"],
  fetchPunchesRequest: ["type", "page", "perPage", "dateRange", "punchesFrom", "onFailure"],
  exportPunchesRequest: [
    "type",
    "page",
    "perPage",
    "dateRange",
    "punchesFrom",
    "onSuccess",
    "onFailure",
  ],
  setInitialFetchIsDone: [],
  setPunchesTotalItems: ["totalItems"],
  setPunchesPerPage: ["perPage"],
  setPunchesPage: ["page"],
  addPunches: ["punches"],
  setPunchesQs: ["qs"],
});

const reducer = createReducer(initialState, {
  [types.ADD_PUNCHES]: (state, { payload }) => ({
    ...state,
    punches: [...payload.punches],
  }),
  [types.SET_LOADING]: (state, { payload }) => ({
    ...state,
    loading: payload.loading,
  }),
  [types.SET_INITIAL_FETCH_IS_DONE]: (state) => ({
    ...state,
    initialFetchIsDone: true,
  }),
  [types.SET_PUNCHES_TOTAL_ITEMS]: (state, { payload }) => ({
    ...state,
    totalItems: payload.totalItems,
  }),
  [types.SET_PUNCHES_PAGE]: (state, { payload }) => ({
    ...state,
    page: payload.page,
  }),
  [types.SET_PUNCHES_PER_PAGE]: (state, { payload }) => ({
    ...state,
    perPage: payload.perPage,
  }),
  [types.SET_PUNCHES_QS]: (state, { payload }) => ({
    ...state,
    qs: payload.qs,
    page: 0,
  }),
});

export { reducer as default, types, actions };
